import {useCallback} from 'react'
import {useLocalStorage} from '@github-ui/use-safe-storage/local-storage'
import {isSidebarGroupBy, resolveSidebarGroupBy, type SidebarGroupBy} from '../utils/filter-utils'

const UNUSED_GROUP_BY_STORAGE_KEY = 'copilot-agent-sessions:sidebar-group-by:'
const isStoredSidebarGroupBy = (value: unknown): value is SidebarGroupBy | null =>
  value === null || isSidebarGroupBy(value)

export function sidebarGroupByStorageKey(login: string): string {
  return `copilot-agent-sessions:sidebar-group-by:${login}`
}

export function useSidebarGroupBy({
  urlGroupBy,
  currentUserLogin,
  filteringEnabled,
}: {
  urlGroupBy: SidebarGroupBy | undefined
  currentUserLogin: string | undefined
  filteringEnabled: boolean
}): {groupBy: SidebarGroupBy; persistGroupBy: (groupBy: SidebarGroupBy) => void} {
  const [storedGroupBy, setStoredGroupBy] = useLocalStorage<SidebarGroupBy | null>(
    currentUserLogin ? sidebarGroupByStorageKey(currentUserLogin) : UNUSED_GROUP_BY_STORAGE_KEY,
    null,
    {validator: isStoredSidebarGroupBy},
  )
  const persistGroupBy = useCallback(
    (groupBy: SidebarGroupBy) => {
      if (!filteringEnabled || !currentUserLogin) return
      setStoredGroupBy(groupBy, {flush: true})
    },
    [filteringEnabled, currentUserLogin, setStoredGroupBy],
  )

  const groupBy = resolveSidebarGroupBy({
    urlGroupBy,
    storedGroupBy: currentUserLogin ? storedGroupBy : null,
    filteringEnabled,
  })

  return {groupBy, persistGroupBy}
}
